import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram,  Youtube,  MessageCircle} from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-pink-600 text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start">
          
          {/* Logo (stays big without affecting links) */}
          <div className="mb-4 md:mb-0 mt-[-40px]">
            <Link to="/" className="block">
              <img
                src="https://ik.imagekit.io/gxibnx8tv/WhatsApp_Image_2025-09-25_at_21.57.10-removebg-preview.png?updatedAt=1758817772219"
                alt="AccessoriesGirly"
                className="h-36 w-auto object-contain" // freely resize here
              />
            </Link>
          </div>

          {/* Footer Links (independent of logo height) */}
          <div className="flex flex-wrap justify-center md:justify-end space-x-6 mb-4 md:mb-0">
            <Link to="/" className="hover:text-pink-200">Home</Link>
            <Link to="/products" className="hover:text-pink-200">Products</Link>
            <Link to="/categories" className="hover:text-pink-200">Category</Link>
            <Link to="/about" className="hover:text-pink-200">About Us</Link>
            <Link to="/contact" className="hover:text-pink-200">Contact Us</Link>
          </div>

          {/* Social Icons */}
          <div className="flex space-x-5">
            <a href="https://www.facebook.com/share/17JNE5KFHu/" target="_blank" rel="noopener noreferrer" className="hover:text-white">
              <Facebook size={22} />
            </a>
            <a href="https://www.instagram.com/accessories_girly70?igsh=bWtvbzN6ZXFlczZm" target="_blank" rel="noopener noreferrer" className="hover:text-white">
              <Instagram size={22} />
            </a>
            <a href="https://youtube.com/@accessoriesgirly?si=dfV40yBK5wZ5sPy0" target="_blank" rel="noopener noreferrer" className="hover:text-white">
              <Youtube size={22} />
            </a>
            <a href="https://whatsapp.com/channel/0029Vb6PkftGufIsz86tLd16" target="_blank" rel="noopener noreferrer" className="hover:text-white">
              <MessageCircle size={22} />
            </a>
          </div>
        </div>

        {/* Bottom Text */}
        <div className="text-center text-pink-200 text-sm mt-6">
          © {new Date().getFullYear()} ShopEase. All rights reserved.
        </div>
      </div>
    </footer>
  );
}